import React from "react";

const Chapter3 = () => {
  return (
    <>
      <h2>Why should I care about CECs in the South Platte River?</h2>
      <p>
        Clean water is one of our most important natural resources – we cannot
        live without it. The more pollution we put into rivers, lakes, and
        groundwater, the more money we must spend to clean it for use as a
        source of drinking water, or for irrigating crops or recreating in. Many
        CECs are designed bioactive organic chemicals which target biological
        processes that are present in multiple species, not just people.
        Widespread use of consumer products that contain CECs result in the
        presence of these chemicals in our rivers, lakes, and groundwater where
        they can harm aquatic life such as fish, that are important for
        ecosystems and recreation. Additionally, the presence of CECs can impact
        drinking water supplies although, more research is needed about possible
        impacts to human health from exposure to CECs.
      </p>
    </>
  );
};

export default Chapter3;
